/**
 * Created by satans17 on 2016/12/11.
 */
import co from 'co';
import queryString from 'querystring';

const util = {};

/**
 * 判断对象类型
 * @param type
 * @returns {Function}
 */
function isType(type) {
  return function returnIsType(obj) {
    return {}.toString.call(obj) === `[object ${type}]`;
  };
}

/**
 * 串行加载模块
 * @param args
 */
function waterfall(...args) {
  const steps = args.shift();
  const tasks = [];

  steps.forEach((item) => {
    tasks.push(new Promise((resolve) => {
      item(...args.concat(() => {
        resolve();
      }));
    }));
  });

  return co(function* coWaterFall() {
    return yield tasks;
  });
}

/**
 * 转换成数据
 * @param o
 * @returns {*}
 */
function makeArray(o) {
  if (o == null) {
    return [];
  }
  if (Object.prototype.toString.call(o) === '[object Array]') {
    return o;
  }
  const lengthType = typeof o.length;
  const oType = typeof o;
  // The strings and functions also have 'length'
  if (lengthType !== 'number' ||
    // select element
    // https://github.com/kissyteam/kissy/issues/537
    typeof o.nodeName === 'string' ||
    // window
    /* jshint eqeqeq:false*/
    (o != null && o === o.window) ||
    oType === 'string' ||
    // https://github.com/ariya/phantomjs/issues/11478
    (oType === 'function' && !('item' in o && lengthType === 'number'))) {
    return [o];
  }
  const ret = [];
  for (let i = 0, l = o.length; i < l; i += 1) {
    ret[i] = o[i];
  }
  return ret;
}

/**
 * 延时模块
 * @param {any}
 * @param {number}
 * @param {any}
 * @returns
 */

function later(fn, when = 0, periodic, context, data) {
  let m = fn;
  const d = makeArray(data);
  if (typeof fn === 'string') {
    m = context[fn];
  }
  const f = () => {
    m.apply(context, d);
  };
  const r = (periodic) ? setInterval(f, when) : setTimeout(f, when);
  return {
    id: r,
    interval: periodic,
    cancel() {
      if (this.interval) {
        clearInterval(r);
      } else {
        clearTimeout(r);
      }
    },
  };
}

/**
 * 将 fn 缓存一段时间后, 再被调用执行
 * @param fn
 * @param ms
 * @param context
 * @returns {*}
 */

function buffer(fn, ms = 150, context) {
  const args = [fn, ms, context];
  if (ms === -1) {
    return () => {
      fn.apply(context || this, args);
    };
  }
  let bufferTimer = null;

  function f() {
    f.stop();
    bufferTimer = later(fn, ms, 0, context || this, args);
  }
  f.stop = () => {
    if (bufferTimer) {
      bufferTimer.cancel();
      bufferTimer = 0;
    }
  };
  return f;
}

function UA() {
  const userAgent = navigator.userAgent;
  const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
  const isAndroid = /(Android)/i.test(userAgent);
  return {
    ios: isIOS,
    android: isAndroid,
  };
}

// webp格式探测
function detectWebp() {
  const cvx = document.createElement('canvas');
  return cvx.toDataURL('image/webp').indexOf('image/webp') > -1;
}

util.isPC = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v += 1) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

util.getVenture = () => {
  if (window.g_config && window.g_config.regionID) {
    return window.g_config.regionID.toLowerCase();
  }
  return window.location.hostname
    .split('.')
    .pop()
    .toLowerCase();
};

util.goldlog = (logEvent) => {
  if (!window.goldlog) return false;
  const isPC = util.isPC();
  const venture = util.getVenture();
  const { goldlog } = window;
  switch (logEvent) {
    case 'CHATBOT_MOBILE_PAGE_INIT':
      if (isPC) return false;
      goldlog.record(`/lazada_chat_${venture}.chatbot.page`,
        'CLK', '', 'GET');
      break;
    case 'CHATBOT_PC_SHOW':
      if (!isPC) return false;
      goldlog.record(`/lazada_chat_${venture}.chatbot.entrance_click`,
        'CLK', '', 'GET');
      break;
    case 'USER_SEND_FIRST_MESSAGE_TO_CHATBOT':
      goldlog.record(`/lazada_chat_${venture}.chatbot.int_chatbot`,
        'CLK', '', 'GET');
      break;
    case 'SWITCH_TO_LIVE_AGENT':
      goldlog.record(`/lazada_chat_${venture}.chatbot.live_chat_transfers`,
        'CLK', '', 'GET');
      break;
    case 'LIVE_CHAT_END_SESSION':
      goldlog.record(`/lazada_chat_${venture}.live_chat.end_session`, 'CLK', '', 'GET');
      break;
    case 'LIVE_CHAT_SEND_PICTURE':
      goldlog.record(`/lazada_chat_${venture}.live_chat.send_picture`, 'CLK', '', 'GET');
      break;
    default:
      return false;
  }
  return util.isPC();
};

util.click = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v += 1) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag ? 'click' : 'tap';
};

util.dateFormat = (ts, fmt) => {
  let res = fmt;
  const date = new Date(ts);
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(res)) {
    res = res.replace(RegExp.$1, (String(date.getFullYear())).substr(4 - RegExp.$1.length));
  }
  // eslint-disable-next-line
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      res = res.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((String(o[k])).length)));
    }
  }
  return res;
};

util.getEnvironment = () => {
  const qs = queryString.parse(location.search.substring(1));
  // 线上
  return qs.env || 'prod';
};

/**
 * 转义
 * @param data
 * @returns {string}
 */
util.htmlEncodeAll = (e) => {
  if (e) {
    return e.replace(/\</g, '&lt;')
      .replace(/\>/g, '&gt;')
      .replace(/\&/g, '&amp;')
      .replace(/'/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  return '';
};

/**
 * 将时间格式化为
 * @param ts
 */
util.parseTime = (ts) => {
  let res = '';
  const now = new Date();
  const day = new Date(ts);
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  // 如果是当天和昨天,显示为今天10:00,昨天10:00
  if (now.toDateString() === day.toDateString()) {
    res = `今天 ${util.dateFormat(new Date(ts), 'hh:mm')}`;
  } else if (yesterday.toDateString() === day.toDateString()) {
    res = `昨天 ${util.dateFormat(new Date(ts), 'hh:mm')}`;
  } else if (new Date(ts).getFullYear() === now.getFullYear()) {
    // 如果是当年,显示为2月14日10:00
    res = util.dateFormat(new Date(ts), 'M月dd日 hh:mm');
  } else {
    // 其他情况.显示2015年10月10日
    res = util.dateFormat(new Date(ts), 'yyyy年M月dd日 hh:mm');
  }
  return res;
};

/**
 * 语言资源工具类
 * @type {null}
 */
util.lang = Object.create({
  __lang: {},
  resetLang(lang) {
    this.__lang = Object.assign(this.__lang, lang);
  },
  get(key, ...args) {
    const str = this.__lang[key] || key;
    return args.length > 0 ? util.format(str, args) : str;
  },
});

/**
 * alicare localStorage
 */
util.storage = (() => {
  const localStorage = window.localStorage;
  const prefix = 'alicare:';

  return {
    setItem(key, val) {
      try {
        localStorage.setItem(prefix + key, val);
      } catch (e) {
        console.log(e);
      }
    },
    getItem(key) {
      try {
        return localStorage.getItem(prefix + key);
      } catch (e) {
        return {};
      }
    },
  };
})();

const raf = window.requestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.mozRequestAnimationFrame
  || window.oRequestAnimationFrame
  || window.msRequestAnimationFrame
  || function setTimeoutRaf(callback) {
    window.setTimeout(callback, 1000 / 60);
  };
/**
 * raf函数
 */
util.requestAnimationFrame = function requestAnimationFrame(fn) {
  return raf.call(window, fn);
};


/**
 * 设置iconfont
 */
util.setIconfont = function setIconfont(url) {
  $('svg').eq(0).remove();
  const script = document.createElement('script');
  const position = document.getElementsByTagName('script')[0];
  script.src = url;
  position.parentNode.insertBefore(script, position);
};

/**
 * 设置css
 */
util.setCss = function setCss(name, url) {
  $('body').attr('class', `skin-${name}`);
  if (!url) {
    return;
  }
  const head = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.id = 'alicarecss';
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  link.media = 'all';
  head.appendChild(link);
};

util.htmlEncodeAll = function htmlEncodeAll(e) {
  // eslint-disable-next-line
  return null == e ? "" : e.replace(/\</g, "&lt;").replace(/\>/g, "&gt;").replace(/\&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")
};

function uuid() {
  let d = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

Object.assign(util, {
  waterfall,
  queryString,
  buffer,
  makeArray,
  later,
  UA,
  detectWebp,
  uuid,
  isObject: isType('Object'),
  isString: isType('String'),
  isNumber: isType('Number'),
  isArray: Array.isArray || isType('Array'),
  isFunction: isType('Function'),
  isUndefined: isType('Undefined'),
});

export default util;



// WEBPACK FOOTER //
// ./src/lib/util.js